export const ITEM_ADD = 'ITEM_ADD';
export const ITEM_MARK_READ = 'ITEM_MARK_READ';
export const ITEM_MARK_UNREAD = 'ITEM_MARK_UNREAD';
